import { inject } from "@angular/core";
import { CanActivateChildFn } from "@angular/router";
import { AreaLinkService } from "src/app/shared/services/area-link.service";

/**
 * Sends area-tagged routes to their own host. The layout and nav are chosen from the hostname, but
 * every route is reachable on every host, so a direct load of e.g. `laketahoeinfo.org/moorings`
 * (TRPA's outreach short link) rendered the parcels mooring page inside the main site layout with no
 * Moorings menu. When the route's `data.area` differs from the current host's area, this does a full
 * cross-host jump to the same path (query string and hash included); shared routes with no
 * `data.area` (About, not-found, ...) stay put.
 */
export const areaHostGuard: CanActivateChildFn = (_childRoute, state) => {
    const crossAreaUrl = inject(AreaLinkService).getCrossAreaUrl(state.url);
    if (crossAreaUrl) {
        window.location.replace(crossAreaUrl);
        return false;
    }
    return true;
};
